import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';
import {
  IDENTIFICATIONCODETYPES_RESOURCE,
  CREATE_IDENTIFICATIONCODETYPE_RESOURCE,
} from '../constants';

const CreateTypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_IDENTIFICATIONCODETYPE_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.identificationCodeTypes(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: IDENTIFICATIONCODETYPES_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createIdentificationCodeTypeFailed'),
            onSuccessMessage: t('createIdentificationCodeTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateTypeService;
